import {
  SESSION_CREATE,
  NO_SESSIONS
} from 'actions/sessionActions';
import { LOGOUT } from 'actions/authActions';

const initialState = {
  sessionList: [],
  sessions: {}
};

export default function auth (state = initialState, action) {
  switch (action.type) {
  case SESSION_CREATE:
    const sessionId = action.sessionId;
    const sessionList = [...state.sessionList];
    if (sessionList.indexOf(sessionId) < 0) {
      sessionList.push(sessionId);
    }
    return {
      sessionList,
      sessions: {
        ...state.sessions,
        [sessionId]: action.data
      }
    };
  case NO_SESSIONS:
    const { ...stateValues } = state;
    return { ...stateValues, empty: true };
  case LOGOUT:
    return { ...initialState };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessionsReducer.js